import {ChecklistModelItem} from './checklistModelItem.model';

export class ChecklistModelItemGroup {
    id: number;
    name: string;
    identifier: string;
    description: string;
    groupOrder: number;
    targetCompletionDays: number;
    activeConditionFormula: string;
    visibilityConditionFormula: string;
    overdueWeight: number;
    checklistModelId: number;
    checklistModelItems: Array<ChecklistModelItem> = [];

    constructor(checklistModelItemGroup: any) {
        if (checklistModelItemGroup) {
            this.id = checklistModelItemGroup.id;
            this.name = checklistModelItemGroup.name;
            this.identifier = checklistModelItemGroup.identifier;
            this.description = checklistModelItemGroup.description;
            this.groupOrder = checklistModelItemGroup.groupOrder;
            this.targetCompletionDays = checklistModelItemGroup.targetCompletionDays;
            this.activeConditionFormula = checklistModelItemGroup.activeConditionFormula;
            this.visibilityConditionFormula = checklistModelItemGroup.visibilityConditionFormula;
            this.checklistModelId = checklistModelItemGroup.checklistModelId;
            if (checklistModelItemGroup.checklistModelItems) {
                checklistModelItemGroup.checklistModelItems.forEach(checklistModelItem => {
                    this.checklistModelItems.push(new ChecklistModelItem(checklistModelItem));
                });
            }
        }
    }
}